module.exports = __webpack_public_path__ + "img/党建园地 手机端.ded3236f.jpg";